import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import '../../../assets/js/admin.js';
import { Router } from '@angular/router';
import { Http, Response, Headers, RequestOptions, ResponseContentType } from '@angular/http';
import { UtilDadosLogado } from '../../servicos/util.logado';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import Swal from 'sweetalert2';
declare var $: any;

@Component({
  selector: 'app-layout-inicial',
  templateUrl: './layout-inicial.component.html',
  styleUrls: ['./layout-inicial.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class LayoutInicialComponent implements OnInit {
  constructor(private router: Router, private http: Http, private UtilDadosLogado: UtilDadosLogado, private sanitizer: DomSanitizer) { }

  tramitesNaoVisualizados: any;
  resultados = [];
  public resulAssinaturaDocumento: any[] = [];
  public listaDocs: any[] = [];
  public assinaturaDocumentoCompleto: any[] = [];
  public ParcelamentoDebito: any[] = [];
  public documentType: string = "";
  public tipoAssinatura: string = "";
  currentPdfId: number | null = null;
  showModal: boolean = false;
  dadosModal: any[] = [];
  tramitesVistos = [];
  selectedItem: any = null;
  showPasswordModal: boolean = false;
  showBadge = null;
  senha: string = '';
  senhaFieldType: string = 'password';
  intervalId;
  Mostrar: any;
  pdfUrl: SafeResourceUrl | null = null;

  ngOnInit() {
    this.tramitesNaoVisualizados = 0;    
    this.startInterval();
  }

  callBackInterval() {
    var btnClick = document.getElementById('btnRefresh');
    btnClick.click();
  }

  logout() {
    localStorage.removeItem('configuracoes');
    this.router.navigate(['/adm']);
  }

  startInterval() {
    this.intervalId = setInterval(this.callBackInterval, 5000);
  }

  public GetTramites() {
    this.Mostrar = true;
    let headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8', 'Access-Control-Allow-Origin': '*', 'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, PATCH, DELETE' });
    let options = new RequestOptions({ headers: headers });

    this.http.post(this.UtilDadosLogado.DadosAcesso().URL + "/api/Inicial/GetTramites", JSON.stringify({
      SEGURADO_ID: this.UtilDadosLogado.DadosAcesso().SEGURADO_ID,
      USR_LOGIN_ID: this.UtilDadosLogado.DadosAcesso().USR_LOGIN_ID,
      PESSOA_ID: this.UtilDadosLogado.DadosAcesso().PESSOA_ID,
    }), options)
      .map((response: Response) => response.json())
      .subscribe(
        data => {
          this.resultados = data.Resultado;
          this.Mostrar = false;
          this.VisualizaTramites();
        },
        error => {
          this.resultados = [];
          this.Mostrar = false;
        }
      );
  }

  public GetTramitesTotalizador() {
    let headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8', 'Access-Control-Allow-Origin': '*', 'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, PATCH, DELETE' });
    let options = new RequestOptions({ headers: headers });

    this.http.post(this.UtilDadosLogado.DadosAcesso().URL + "/api/Inicial/GetTramitesTotalizador", JSON.stringify({
      SEGURADO_ID: this.UtilDadosLogado.DadosAcesso().SEGURADO_ID,
      USR_LOGIN_ID: this.UtilDadosLogado.DadosAcesso().USR_LOGIN_ID,
      PESSOA_ID: this.UtilDadosLogado.DadosAcesso().PESSOA_ID,
    }), options)
      .map((response: Response) => response.json())
      .subscribe(
        data => {
          this.tramitesNaoVisualizados = data.Total;
        },
        error => {
          this.tramitesNaoVisualizados = 0;
        }
      );
  }

  public meusTramites() {
    $("#ModalMeusTramites").show();
    this.GetTramites();
  }

  public closeMeusTramites() {
    $("#ModalMeusTramites").hide();
  }

  public assinarDocumento() {
    $("#ModalAssinaturaDocumento").show();
    this.GetAssinarDocumento();
  }

  public cloaseAssinarDocumento() {
    $("#ModalAssinaturaDocumento").hide();
  }

  public VisualizaTramites() {
    let headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8', 'Access-Control-Allow-Origin': '*', 'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, PATCH, DELETE' });
    let options = new RequestOptions({ headers: headers });

    this.http.post(this.UtilDadosLogado.DadosAcesso().URL + "/api/Inicial/VisualizarTramites", JSON.stringify({
      DADOS: this.resultados,
      USR_LOGIN_ID: this.UtilDadosLogado.DadosAcesso().USR_LOGIN_ID
    }), options)
      .map((response: Response) => response.json())
      .subscribe(
        data => {
        },
        error => {

        }
      );
  }

  public GetAssinarDocumento() {
    this.Mostrar = true;
    let headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8', 'Access-Control-Allow-Origin': '*', 'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, PATCH, DELETE' });
    let options = new RequestOptions({ headers: headers });

    this.http.post(this.UtilDadosLogado.DadosAcesso().URL + "/api/Inicial/GetAssinarDocumento", JSON.stringify({
      SEGURADO_ID: this.UtilDadosLogado.DadosAcesso().SEGURADO_ID,
      USR_LOGIN_ID: this.UtilDadosLogado.DadosAcesso().USR_LOGIN_ID,
      PESSOA_ID: this.UtilDadosLogado.DadosAcesso().PESSOA_ID,
    }), options)
      .map((response: Response) => response.json())
      .subscribe(
        data => {
          if (data && data.TipoDocumento && data.TipoDocumento.length > 0) 
          {
                
                if (data.TipoDocumento.find(t => t.doc === "termoOpcao")) 
                {
                  const registro = data.Resultado.find(r => r.tipoDados === "termoOpcao");
                  const docDados = data.TipoDocumento

                  if (registro && registro.dados && registro.dados.length > 0 && data.TipoDocumento.length > 0) {
                    const primeiroDoc = data.TipoDocumento[0].docDados[0];
                    registro.dados[0].descricao = "Termo de Opção";
                    registro.dados[0].Usuario = primeiroDoc.UsrLoginNome;
                    registro.dados[0].data = primeiroDoc.DataInsert;
                    this.assinaturaDocumentoCompleto = registro.dados;
                    this.documentType = "termoOpcao";
                    this.resulAssinaturaDocumento = registro.dados.slice(0, 1);
                  } else {
                    this.resulAssinaturaDocumento = [];
                    this.assinaturaDocumentoCompleto = [];
                    this.documentType = "";
                  }
                }

                if (data.TipoDocumento.find(t => t.doc === "termoParcelamento")) 
                  {
                    const registro = data.Resultado.find(r => r.tipoDados === "termoParcelamento");

                    if (registro) {
                      const listaDocsAss: any[] = [];
                      const base = registro.dados && registro.dados.length ? registro.dados[0] : {};
                    
                      data.TipoDocumento
                        .filter((tipo: any) => tipo.doc === "termoParcelamento")
                        .forEach((tipo: any) => {
                          if (tipo.docDados && tipo.docDados.length) {
                            tipo.docDados.forEach((doc: any) => {
                              listaDocsAss.push({
                                ...base,
                                tipoDados: "termoParcelamento",
                                descricao: "Termo de Parcelamento",
                                Usuario: doc.UsrLoginNome,
                                data: doc.DataInsert,
                                DocumentoId: doc.DocumentoId || doc.IdDocumento,
                                docId: doc.DocId,
                                Dados: doc.Dados,
                                docDados: doc,
                                selecionado: false
                              });
                            });
                          }
                        });

                if (listaDocsAss.length > 0) {
                  this.assinaturaDocumentoCompleto = listaDocsAss;
                  this.documentType = "termoParcelamento";
                  this.tipoAssinatura = "termoParcelamento";
                  this.resulAssinaturaDocumento = listaDocsAss;
                }
              }
                }
          }
          else 
          {
            this.resulAssinaturaDocumento = [];
            this.assinaturaDocumentoCompleto = [];
            this.documentType = "";
          }
          this.Mostrar = false;
        },
        error => {
          this.resulAssinaturaDocumento = [];
          this.assinaturaDocumentoCompleto = [];
          this.documentType = "";
          this.Mostrar = false;
        }
      );
  }

 openRoutine(docType: string, dadosCompletos: any): void {
  if (docType === "termoOpcao") {
    this.dadosModal = Array.isArray(dadosCompletos) ? dadosCompletos : [dadosCompletos];
    this.showModal = true;
    return;
  }

  if (docType === "termoParcelamento") {
    const item = dadosCompletos;

    if (!item || !item.Dados) {
      return;
    }

    this.abrirPdfBase64(item.Dados);
    return;
  }
}

abrirPdfBase64(base64: string): void {
  try {
    const conteudo = base64.indexOf(",") >= 0 ? base64.split(",")[1] : base64;
    const byteCharacters = atob(conteudo);
    const byteNumbers = new Array(byteCharacters.length);

    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: "application/pdf" });
    const url = window.URL.createObjectURL(blob);

    window.open(url, "_blank");
  } catch (e) {
   
  }
}

  fecharModal(): void {
    this.showModal = false;
    this.dadosModal.forEach(item => item.selecionado = false);
  }

  fecharPasswordModal(): void {
    this.showPasswordModal = false;
    this.senha = ''; // opcional: limpar a senha ao fechar
  }

  confirmarAssinatura(): void {
    // Filtra os itens marcados com o checkbox
      const selecionados = this.resulAssinaturaDocumento.filter(item => item.selecionado);

  const idsTermoOpcao = selecionados
    .filter(item => item.tipoDados === "termoOpcao")
    .map(item => item.TermoOpcaoEnviadaAssinaturaId);

  const idsParcelamento = selecionados
    .filter(item => item.tipoDados === "termoParcelamento")
    .map(item => item.DocumentoId || item.docId);

  const ids = idsTermoOpcao.concat(idsParcelamento);

  if (ids.length === 0) {
    Swal.fire({
      title: "Atenção!",
      type: "warning",
      text: "Nenhum documento selecionado para assinatura."
    });
    return;
  }

  const possuiParcelamentoDebido = idsParcelamento.length > 0 ? "S" : "N";

        
        const payload = {
          ids: ids == null ? this.ParcelamentoDebito.map(item => item.DocumentoId) : ids,
          senha: this.senha,
          seguradoId: this.UtilDadosLogado.DadosAcesso().SEGURADO_ID,
          usrLogin: this.UtilDadosLogado.DadosAcesso().USR_LOGIN_ID,
          ParcelamentoDebido: possuiParcelamentoDebido
        };
      
    let headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8' });
    let options = new RequestOptions({ headers: headers });

    this.http.post(
      this.UtilDadosLogado.DadosAcesso().URL + "/api/Inicial/AssinarDocumento",
      JSON.stringify(payload),
      options
    )
      .map((response: Response) => response.json())
      .subscribe(
        data => {
          this.GetAssinarDocumento();
          Swal.fire({
            title: "Atenção!",
            type: "success",
            text: data
          });
        },
        error => {
          var erro = error._body != null ? error._body : error;
          this.showModal = true;
          Swal.fire({
            title: "Atenção!",
            type: "error",
            text: erro
          });
        }
      );

    // Fecha ambos os modais
    this.fecharPasswordModal();
    this.fecharModal();
  }

  openPasswordModal(): void {
    const selecionados = this.dadosModal.filter(item => item.selecionado);
    if (selecionados.length === 0) {
      Swal.fire({
        title: "Atenção!",
        type: "warning",
        text: "Selecione uma regra!"
      });

      return;
    }
    this.showPasswordModal = true;
  }

  openAssiInicial(): void {
  const selecionados = this.resulAssinaturaDocumento.filter(item => item.selecionado);

  if (selecionados.length === 0) {
    Swal.fire({
      title: "Atenção!",
      type: "warning",
      html: "Selecione ao menos um documento"
    });
    return;
  }

  if (this.tipoAssinatura === "termoParcelamento") {
    this.ParcelamentoDebito = selecionados.filter(item => item.tipoDados === "termoParcelamento");
  } else {
    this.ParcelamentoDebito = [];
  }

  this.showPasswordModal = true;
}

  openPdf(item: any): void {
    if (this.selectedItem && this.selectedItem.TermoOpcaoEnviadaAssinaturaId === item.TermoOpcaoEnviadaAssinaturaId) {
      this.selectedItem = null;
      this.pdfUrl = null;
      return;
    }
    this.selectedItem = item;

    if (item.TermoOpcaoEnviadaAssinaturaId) {
      const id = item.TermoOpcaoEnviadaAssinaturaId;
      const url = this.UtilDadosLogado.DadosAcesso().URL + "/api/Inicial/GetPdfDocumento?id=" + id;
      let headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8' });
      let options = new RequestOptions({
        headers: headers,
        responseType: ResponseContentType.Blob
      });

      this.http.get(url, options)
        .map((response: Response) => response.blob())
        .subscribe(
          (blob: Blob) => {
            const fileURL = URL.createObjectURL(blob);
            this.pdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(fileURL);
          },
          error => {
            this.pdfUrl = null;
          }
        );
    } else {
      this.pdfUrl = null;
    }
  }

  isSelected(item: any): boolean {
    return this.selectedItem && this.selectedItem.TermoOpcaoEnviadaAssinaturaId === item.TermoOpcaoEnviadaAssinaturaId;
  }

  onCheckboxChange(item: any, event: MatCheckboxChange): void {
    item.selecionado = event.checked;
  }

}
